import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  SelectInput,
  Edit,
  EditProps,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomFormLabel from "components/CustomFormLabel";
import CustomEditToolbar from "components/CustomEditToolbar";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import ParentInput from "./components/ParentInput";
import StudentInput from "./components/StudentInput";
import {
  busScheduleStatusList,
  formTypeList,
  invoiceStatusList,
  statusList,
} from "./conts";

const ChangeRequestEdit = (props: EditProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/changeRequestForms", title: "Change Request Forms" },
    { link: `/changeRequestForms/${id}`, title: id },
  ];

  const transform = async (data: any) => {
    return data;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} isDefaultTitle />
      <Edit {...props} transform={transform} undoable={false}>
        <SimpleForm toolbar={<CustomEditToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>

            <Grid item xs={4}>
              <StudentInput disabled />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Change Request Detail</Typography>
            </Grid>

            <Grid item xs={4}>
              <CustomDatePickerInput name="wefDate" label="Wef Date *" />
            </Grid>
            <Grid item xs={4}>
              <CustomDatePickerInput name="endDate" label="End Date *" />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <SelectInput
                choices={formTypeList}
                source="type"
                validate={required()}
                disabled
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <SelectInput
                choices={busScheduleStatusList}
                source="busScheduleStatus"
                label="Routeplanner Role"
                validate={required()}
              />
            </Grid>
            <Grid item xs={4}>
              <SelectInput
                choices={invoiceStatusList}
                source="invoiceStatus"
                label="CS Role"
                validate={required()}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <SelectInput
                choices={statusList}
                source="status"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput multiline rows={3} source="csDescription" />
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Edit>
    </>
  );
};

export default ChangeRequestEdit;
